export const publisherswitchActions = {
    showPublishers,
}

function showPublishers(mode) {
    return dispatch => {
        dispatch({ type: mode });
    }
}